import clsx from 'clsx';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className={clsx('tw-bg-blue-900', 'tw-py-8', 'tw-relative', 'md:tw-px-48')}>
      {/* Top Gradient Divider */}
      <div
        className={clsx(
          'tw-absolute',
          'tw-top-0',
          'tw-left-0',
          'tw-w-full',
          'tw-h-6',
          'bg-gradient-to-r',
          'from-blue-400',
          'via-purple-500',
          'to-pink-500',
          'top-gradient-divider'
        )}
      />
      <div
        className={clsx(
          'tw-container',
          'tw-mx-auto',
          'tw-px-6',
          'lg:tw-px-8',
          'tw-flex',
          'tw-flex-col',
          'lg:tw-flex-row',
          'tw-items-center',
          'lg:tw-justify-between',
          'tw-text-white',
          'tw-text-center',
          'lg:tw-text-left',
          'md:tw-mt-16',
          'md:tw-mb-24'
        )}
      >
        {/* Left Section */}
        <div className={clsx('tw-mb-6', 'lg:tw-mb-0')}>
          <div
            className={clsx(
              'tw-flex',
              'tw-items-center',
              'tw-justify-center',
              'lg:tw-justify-start',
              'tw-mb-4',
              'md:tw-pb-16',
              'tw-py-6'
            )}
          >
            <img
              src={'images/cloudcfo-logo-white.png'} // Replace with your logo path
              alt="CloudCFO Logo"
              className={clsx('tw-h-8', 'tw-mr-2 ')}
              style={{ width: '200px', height: 'auto' }}
            />
          </div>
          <div>
            <h6 className={clsx('tw-font-semibold', 'tw-mb-8')}>For Concerns & Clarifications:</h6>
            <a
              href="mailto:support@cloudcfo.ph"
              className={clsx(
                'tw-bg-white',
                'tw-text-[#072B5F]',
                'tw-rounded-full',
                'tw-py-4',
                'tw-px-4',
                'tw-text-[12px]',
                'tw-inline-block',
                'hover:tw-bg-blue-100',
                'md:tw-mb-0',
                'xs:tw-mb-10'
              )}
            >
              support@cloudcfo.ph
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className={clsx('tw-mt-auto', 'tw-self-center')}>
          <h6 className={clsx('tw-font-semibold', 'tw-mb-8')}>Connect With Us:</h6>
          <div
            className={clsx(
              'tw-flex',
              'tw-justify-center',
              'lg:tw-justify-end',
              'tw-space-x-4',
              'md:tw-gap-5',
              'tw-gap-8'
            )}
          >
            <a
              href="https://www.facebook.com/cloudcfoph/"
              target="_blank"
              className={clsx('tw-text-white', 'hover:tw-opacity-75')}
              rel="noreferrer"
            >
              <img
                src={'images/facebook.svg'}
                alt="Facebook"
                className={clsx('tw-h-auto', 'md:tw-w-[32px]', 'tw-w-12')}
              />
            </a>
            <a
              href="https://www.instagram.com/cloudcfo.ph/?hl=en"
              target="_blank"
              className={clsx('tw-text-white', 'hover:tw-opacity-75')}
              rel="noreferrer"
            >
              <img
                src={'images/instagram.svg'}
                alt="Instagram"
                className={clsx('tw-h-auto', 'md:tw-w-[32px]', 'tw-w-12')}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/cloudcfo-inc/posts/?feedView=all"
              target="_blank"
              className={clsx('tw-text-white', 'hover:tw-opacity-75')}
              rel="noreferrer"
            >
              <img
                src={'images/linkedin.svg'}
                alt="Linkedin"
                className={clsx('tw-h-auto', 'md:tw-w-[32px]', 'tw-w-12')}
              />
            </a>
          </div>
        </div>
      </div>
      <hr
        className={clsx(
          'tw-border-t',
          'tw-border-white',
          'tw-w-full',
          'tw-my-4',
          'tw-hidden',
          'md:tw-block'
        )}
      />
      <div
        className={clsx(
          'tw-container',
          'tw-mx-auto',
          'tw-px-6',
          'lg:tw-px-8',
          'tw-mt-8',
          'md:tw-text-right',
          'tw-text-center',
          'tw-text-white',
          'tw-text-xl'
        )}
      >
        @ {new Date().getFullYear()} CloudCFO Inc.
      </div>
    </footer>
  );
};

export default Footer;
